import React from 'react';
import PropTypes from 'prop-types';
import { M } from '@dashboard-experience/mastodon';
import DOMPurify from 'isomorphic-dompurify';
import { i18n } from '@international/mastodon-i18n';
import { DISPUTES_FLOW } from 'identifiers/identifiers';
import { getSectionDisplayName } from '../lib/screenings';

const ArticleText = ({ section, article, companyName }) => {
  const articleBody = article.body || '';
  const body = companyName
    ? articleBody.replace(/\[Company name\]/g, () => companyName)
    : articleBody;
  return (
    <div data-testid={DISPUTES_FLOW.disputeArticleText}>
      <div className='form-group'>
        <label>
          <span className='text-muted'>
            {getSectionDisplayName(section)} &#62;{' '}
          </span>
          <span className='form-question'>{article.title}</span>
        </label>
        <hr />
      </div>
      <div className='d-flex flex-column text-center'>
        <M.Icon
          data-testid={DISPUTES_FLOW.disputeForumIcon}
          icon='Forum'
          className='checkr-blue'
        />
        <div
          data-testid={DISPUTES_FLOW.disputeArticleBody}
          className='m-4'
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(body) }}
        />
      </div>
    </div>
  );
};

ArticleText.propTypes = {
  section: PropTypes.string,
  article: PropTypes.object,
  companyName: PropTypes.string,
};

ArticleText.defaultProps = {
  section: '',
  article: {},
  companyName: '',
};

export default i18n.renderTranslation()(ArticleText);
